<template>
  <div>
    <ReportStatusTable
      is-example
      :per-page="exampleList.length"
      :rows-per-page="rowsPerPage"
      :table-data="exampleList"
      :total-records="exampleList.length"
    />
  </div>
</template>

<script>
// Components
import ReportStatusTable from '@/pages/your-reports/components/ReportStatusTable'
// model
import { exampleList } from '@/pages/your-reports/model/report-example'
//mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  name: 'ReportExamples',
  components: {
    ReportStatusTable,
  },
  mixins: [deviceWidthMixin],
  props: {
    isPaymentHistoryOpen: {
      type: Boolean,
      default: false,
    },
    rowsPerPage: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      exampleList,
    }
  },
}
</script>
